import { HttpErrorResponse } from '@angular/common/http';
import { HcToasterService } from '@healthcatalyst/cashmere';
import { Subscription, timer } from 'rxjs';
import { IHttpErrorResponseWithHandler } from './interfaces';

export class HttpErrorResponseToastHandler extends HttpErrorResponse implements IHttpErrorResponseWithHandler {
    private defaultHandler: Subscription;

    public constructor(
        public override error: HttpErrorResponse,
        private toasterService: HcToasterService
    ) {
        super({ ...error, url: undefined });
        this.setupDefaultHandler();
    }

    public preventDefaultHandler(): void {
        this.defaultHandler.unsubscribe();
    }

    private setupDefaultHandler(): void {
        this.defaultHandler = timer(0).subscribe(() => {
            if (this.error.status === 403 && this.error.message.includes('/roles/applications/')) {
                this.toasterService.addToast({
                    type: 'warning',
                    header: 'Permissions',
                    body: `You do not have permissions to manage application roles`,
                    position: 'bottom-right'
                });
            } else if (this.error.status < 500 && (this.error.error?.detail || this.error.message)) {
                this.toasterService.addToast({
                    type: 'alert',
                    header: `Error Code: ${this.error.error?.status || this.error.status}`,
                    body: this.error.error?.detail || this.error.message,
                    position: 'bottom-right'
                });
            } else {
                this.toasterService.addToast({
                    body: `If problems persist, please contact support.`,
                    header: 'Unexpected Error',
                    type: 'alert'
                });
                console.error(
                    `Error Code: ${this.error.error?.status || this.error.status}\n${this.error.error?.detail || this.error.message}`,
                    this.error
                );
            }
        });
    }
}

/**
 *
 * @param error
 * @returns IHttpResponseErrorWithHandler narrowed compatible type
 * see https://www.typescriptlang.org/docs/handbook/2/narrowing.html#using-type-predicates
 */
export function isHttpErrorResponseWithHandler(error: Error): error is IHttpErrorResponseWithHandler {
    return (error as IHttpErrorResponseWithHandler).preventDefaultHandler !== undefined;
}
